import api from './useApi';

export interface NotaNfcom {
  id: number;
  fatura_id: number;
  cliente_id?: number;
  escritorio_id?: number;
  gateway_id?: number;
  numero?: number | null;
  serie: number;
  chave_acesso?: string;
  protocolo?: string;
  data_autorizacao?: string;
  data_cancelamento?: string;
  motivo_status?: string;
  status: 'autorizado' | 'rejeitado' | 'cancelado' | 'processando' | 'error';
  ambiente?: string;
  nfcom_id_gateway?: string;
  xml?: string;
  pdf?: string;
  itens?: any;
  valor_total: number;
  bc_icms?: number;
  icms?: number;
  cliente_nome: string;
  cliente_cpf: string;
  createdAt: string;
  updatedAt: string;
}

async function getAll(): Promise<NotaNfcom[]> {
  const response = await api.get('/notas-nfcom');
  // API pode responder diretamente com array ou dentro de data
  return (response as any)?.data?.data || (response as any)?.data || response;
}

async function getByClienteId(clienteId: number): Promise<NotaNfcom[]> {
  const notas = await api.get(`/notas-nfcom/client/${clienteId}`);
  return (notas as any)?.data?.data || (notas as any)?.data || notas;
}

async function gerarLote(params: { data_emissao: string; fatura_ids: number[] }) {
  const resp = await api.post('/notas-nfcom/gerar-lote', params);
  return (resp as any)?.data || resp;
}


export const nfcomService = {
  getAll,
  getByClienteId,
  gerarLote,
};

export default nfcomService;